import { mallApi, mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const similygoods = {
  getGoodsDetail: data => mallApi.post(apiPath.getGoodsDetail, data),
  getGoodsInfoLocation: data =>
    mallEntranceApi.post(apiPath.getGoodsInfoLocation, data)
}
